import React from "react";
import { useTranslation } from "react-i18next";
import { BrandLogo } from "@/components/common/BrandLogo";

export const LoadingScreen = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background" data-testid="loading-screen" role="status">
      <BrandLogo size="lg" />
      <div className="h-1 w-40 overflow-hidden rounded-full bg-muted">
        <div className="h-full w-1/3 animate-[og-slide_1.2s_ease-in-out_infinite] rounded-full bg-primary" />
      </div>
      <span className="text-xs text-muted-foreground">{t("common.loading")}</span>
    </div>
  );
};
